module.exports = __webpack_public_path__ + "static/media/nimes_amphi.f18ef6cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Provence/nimes_amphi.png
// module id = 729
// module chunks = 0